import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetEligibleOptions = function (tariffId) {
    return useApiCall(function (signal) { return api.eligibility.apiEligiblityGet(tariffId, { signal: signal }); }, [], !!tariffId, [tariffId]);
};
